/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { ModalHeader } from '../Modal';
import { ControlTable } from '../Table';
import { COMPANY_MANAGER_LEVEL } from '../../constants/COMPANY';
import { isEmpty } from '../../utils/lodashExtend';
import Button from '../Button';
import { viewLoading } from '../../utils/loading';
import { modeifyTaxpayerManagers } from '../../apis/tax-portal/taxpayer';
import { toast } from '../../utils/toast';
import { useDispatch } from 'react-redux';
import { getStoreCompanies } from '../../store/actions';
import { getManagerCompanyEmployees } from '../../apis/companies/roles';
import { get } from 'lodash';
import Radios from '../Radio/Radios';

const ManagerForm = ({ taxpayer, company, cancel }) => {
  const dispatch = useDispatch();
  const [managers, setManagers] = useState([]);
  const [manageComEmployees, setManageComEmployees] = useState([]);
  const [employeeFields, setEmployeeFields] = useState([]);

  const initManager = () => {
    getManagerCompanyEmployees(company.managerCompanyIdx || company.idx)
      .then((res) => {
        const manageComEmployees = get(res, "data.employees", []);
        setManageComEmployees(manageComEmployees);
        const managers = taxpayer.taxpayerManagerEmployees || [];

        const _managers = manageComEmployees.map(item => {
          const manager = managers.find(f => f.idx === item.idx);
          let level = manager?.companyManagerPerson?.level > 0 ? `${manager?.companyManagerPerson?.level}` : "0";
          return {
            managerIdx: item.idx,
            level
          };
        });

        setManagers(_managers);
      });
  };

  const handleSumbit = () => {
    viewLoading("매니저 설정중입니다.");
    const form = {
      type: company.type,
      managerComIdx: company.managerCompanyIdx || company.idx,
      managers: managers.filter(f => f.level !== "0").map(item => ({ ...item, level: +item.level })),
      taxpayerIdxes: [taxpayer.idx]
    };

    modeifyTaxpayerManagers(form)
      .then(() => {
        toast.success('매니저 설정이 완료되었습니다.');
        cancel();
      })
      .catch(() => { })
      .finally(() => {
        viewLoading(false);
        dispatch(getStoreCompanies());
      });

  };

  useEffect(() => {
    company && taxpayer && initManager();
  }, [company, taxpayer]);

  useEffect(() => {
    setEmployeeFields([
      { title: "직원명", key: "name" },
      { title: "직원코드", key: "code" },
      {
        title: "담당권한",
        type: "component",
        key: "level",
        component: ({ data }) => {
          return (
            <Radios
              name="level"
              field={{
                options: { list: COMPANY_MANAGER_LEVEL },
                key: `employee-${data.idx}-level`,
                defaultChecked: managers.find(f => f.managerIdx === data.idx)?.level,
                onChange: (e) => {
                  const _managers = manageComEmployees.map(employee => {
                    const findManager = managers.find(f => f.managerIdx === employee.idx);
                    const isChangeLevel = data.idx === employee.idx;
                    let level = isChangeLevel ? e.target.value : findManager?.level;
                    return {
                      managerIdx: employee.idx,
                      level: COMPANY_MANAGER_LEVEL.find(f => f.value === level)?.value || "0"
                    };
                  });
                  setManagers(_managers);
                }
              }}
            />
          );
        },
      },
      { title: "입사일", key: "joinDate" },
    ]);
  }, [manageComEmployees, managers]);

  return (
    <div className="manager-company-write">
      <div className="manager-company-second-step">
        <ModalHeader>{`${company.name} 직원 목록`}</ModalHeader>
        <ControlTable
          fields={employeeFields}
          list={manageComEmployees}
        />
        <div className="control-button-wrap">
          <Button
            className="button"
            label="설정"
            disabled={isEmpty(managers.find(f => f.level === "2" || f.level === "1"))}
            onClick={handleSumbit}
          />
          <Button
            className="button"
            color="text"
            label="취소"
            onClick={cancel}
          />
        </div>
      </div>
    </div>
  );
};

export default ManagerForm;